import { render, staticRenderFns } from "./ComplianceDiagramm.vue?vue&type=template&id=658ff4b2&scoped=true"
import script from "./ComplianceDiagramm.vue?vue&type=script&lang=js"
export * from "./ComplianceDiagramm.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDiagramm.vue?vue&type=style&index=0&id=658ff4b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ff4b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
